import {Outlet} from "react-router-dom";

const FavoritePrescriptions = () => {
  return <Outlet/>
}

export default FavoritePrescriptions;